import { IChatMessage } from "../../../types/chat"
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react"
import clsx from "clsx"
import { urlify } from "../../../utils/urlify"
import { CrossIcon } from "../../../icons/CrossIcon"
import { setIDMessageToOpen } from "../../../redux/slice/chat"
import { useDispatch } from "react-redux"
import { videoFormats } from "../../../utils/constants"
import { getApiUrl } from "../../../utils/getApiUrl"
import { useTranslation } from "react-i18next"
import s from "./ChatReply.module.scss"

interface Props {
  message?: IChatMessage
  setReplyMessage?: Dispatch<SetStateAction<IChatMessage | null>>
}

const ChatReply = ({ message, setReplyMessage }: Props) => {
  const dispatch = useDispatch()
  const { t } = useTranslation("translation", { keyPrefix: `interface` })

  const [isNew, setIsNew] = useState<boolean>(false)

  useEffect(() => {
    setIsNew(!!setReplyMessage)
  }, [])

  const imgBlock = useMemo(() => {
    if (!message?.photos_info?.length) return null
    const photo = message.photos_info[0]
    const fileName = photo?.filename?.split(".")?.pop()?.toLowerCase() ?? ""
    const isVideoEl = videoFormats.some((videoEl: any) => videoEl === fileName)
    let photoSrc = getApiUrl() + "/public/photo/preview/" + photo?.id
    if (isVideoEl) {
      photoSrc = getApiUrl() + "/public/photo/preview/" + photo?.previewId
    }

    return <img src={photoSrc} alt={""} className={s.img} />
  }, [message?.text, message?.photos_info])

  const infoTxt = useMemo(() => {
    if (message?.text) {
      return <div className={s.txt} dangerouslySetInnerHTML={{ __html: urlify(message?.text) }} />
    }
    if (message?.photos_info?.length) {
      return <div className={clsx(s.txt, s.txtImg)}>{t("photo")}</div>
    }
    if (message?.attachments_info?.length) {
      return (
        <div className={s.txt}>
          {t("file")} {message.attachments_info[0].filename}
        </div>
      )
    }
    return null
  }, [message?.text, message?.photos_info, message?.attachments_info])

  if (!message?.id) return null

  return (
    <div className={clsx(s.reply, isNew && s["reply--is-new"], imgBlock && s["reply--is-img"])}>
      <div
        className={s.info}
        onClick={() => {
          if (!isNew) dispatch(setIDMessageToOpen(message.id))
        }}
      >
        {imgBlock}
        <div className={s.txtWrap}>
          <h4 className={s.title}>{message.user.name}</h4>
          {infoTxt}
        </div>
      </div>
      {setReplyMessage && (
        <button type="button" className={s.btnClose} onClick={() => setReplyMessage(null)}>
          <CrossIcon />
        </button>
      )}
    </div>
  )
}

export default ChatReply
